import React from "react";
import { DateOrDateString } from "../../../defines";

export enum VeriDatePickerView {
  Days,
  YearsAndMonths,
}

export interface VeriDatePickerOptions {
  onDateChange?: (date?: string | null) => void;
  onRangeChange?: (startDate?: Date | null, endDate?: Date | null) => void;
  onDayPick?: (date: Date | null) => void;
  maxDate?: DateOrDateString;
  minDate?: DateOrDateString;
  enabledDates?: DateOrDateString[];
  disabledDates?: DateOrDateString[];

  rangeStartDate?: string;
  rangeEndDate?: string;
  isRangePicker?: boolean;
}

export interface VeriDatePickerState extends VeriDatePickerOptions {
  date: Date | null;
  nowDate: Date | null;
  dateString: string | null;
  selectedDate: Date | null;
  selectedDateString: string | null;
  view: VeriDatePickerView;
  yearStep: number;
}

export interface VeriDatePickerContext extends VeriDatePickerState {
  setDatePickerState: React.Dispatch<VeriDatePickerState>;
  changeState: <K extends keyof VeriDatePickerState>(
    key: K,
    value: VeriDatePickerState[K],
  ) => void;
  isDateEnabled: (date: DateOrDateString) => boolean;
  isDateInRange: (date: DateOrDateString) => boolean;
  isFirstDateInRange: (date: DateOrDateString) => boolean;
  isLastDateInRange: (date: DateOrDateString) => boolean;
  setDate: (date: DateOrDateString) => void;
  setDateValue: (date: DateOrDateString) => void;
  setRangeDates: (
    startDate: DateOrDateString,
    endDate: DateOrDateString,
  ) => void;
}

export interface VeriDatePickerContextProps
  extends Partial<VeriDatePickerContext> {
  initialDate?: Date;
  initialDateString?: string;
}
